
<template>
  <div :id="id" :class="className" :style="{ height, width }" />
</template>
  
<script lang="ts">
import { defineComponent, onActivated, onBeforeUnmount, onDeactivated, onMounted, nextTick, reactive, toRefs, watch } from 'vue'
import { init, EChartsOption } from 'echarts'
import { robotTotalStatus } from "@/apis/home";
import i18n from "@/locales/index";
const _t = i18n.global.t;
import { getLanguage } from "@/utils/cookies";
export default defineComponent({
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'echartsAnTotalComponents'
    },
    width: {
      type: String,
      default: '400px',
      required: true
    },
    height: {
      type: String,
      default: '200px',
      required: true
    },
    chartsData: {
      type: Object,
      default: ''
    }
  },
  setup(props) {
    const state = reactive({
      colorArr: [] as any,
      language: getLanguage(),
      graphic_left(){
        if(state.language == 'en'){
          return 92
        }else if(state.language == 'zh-cn'){
          return 92
        }else if(state.language == 'ko'){
          return 85
        }else if(state.language == 'de'){
          return 78
        }else if(state.language == 'fr'){
          return 65
        }else if(state.language == 'ja'){
          return 85 
        }else if(state.language == 'nl'){
          return 68
        }else if(state.language == 'pl'){
          return 75
        }
      },
      legend_left() {
        if(state.language == 'ja'){
          return '55%'
        }else {
          return '60%'
        }
      },
    })
    const initChart = () => {
      const robotTotalEcharts = init(document.getElementById(props.id) as HTMLDivElement)

      robotTotalEcharts.setOption({
        tooltip: {
          trigger: 'item',
          formatter: (params: any) => {
            // let index = params.dataIndex
            return `${params.data.name}` + '<br/>' + `${params.data.value}` + _t('account.platform')
          },
        },
        legend: {
          itemHeight: 10,
          itemWidth: 10,
          orient: 'vertical',
          left: state.legend_left(),
          y: '15%',
          icon: "circle",
        },
        graphic: {
          type: 'text',     // 类型：文本
          left: state.graphic_left(),
          bottom: 10,
          silent: true,     // 不响应事件
          invisible: props.chartsData.length > 0,   // 有数据就隐藏
          style: {
            fill: 'rgba(0, 0, 0, 0.25)',
            fontWeight: 'bold',
            text: _t('system.noData'),
            fontFamily: 'Microsoft YaHei',
            fontSize: '14'
          }
        },
        color: ['#45A0FF', '#59CB74', '#FBD34A', 'rgba(0,0,0,0.05)', '#F4657B'],
        series: [
          {
            // name: '阿萨德',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            center: ['30%', '45%'],
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 10,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: props.chartsData
          }
        ]
      } as EChartsOption)
    }


    // watch(() => props.chartsData, (newVal, oldVal) => {
    //   if (newVal) {
    //     nextTick(() => {
    //       initChart()
    //     })
    //   }
    // })

    onMounted(() => {
      setTimeout(() => {
        initChart()
      }, 500)
    })

    onBeforeUnmount(() => {

    })

    onActivated(() => {

    })

    onDeactivated(() => {

    })

    return {
      ...toRefs(state)
    }
  }
})
</script>
  
<style scoped>
.chart {}
</style>
  